<template>
  <div class="home">
    <mynav1 :data='nvdata'></mynav1>
    <!-- <imgct></imgct> -->
    <div id="fmd1">
      <div>智慧三农服务解决方案</div>
      <label>巩固拓展脱贫攻坚成果  &nbsp;发展农村数字普惠金融</label>
    </div>
    <div id="fmd2">
      <div>终端产品</div>
    </div>
    <div id="fmd3">
      <div>基层服务站点建设</div>
    </div>
    <div id="fmd4">
      <div>便民服务、教育培训</div>
    </div>
    <div id="fmd5">
      <div>信息查询、村务管理、党建服务</div>
    </div>
    <div id="fmd6">
      <div>金融服务</div>
    </div>
    <div id="fmd7">
      <div>案例展示</div>
    </div>
    <myfooter :data='ftdata'></myfooter>
  </div>
</template>
<style>

#fmd1 {
  height: 9rem;
  background-image: url('../assets/pic/solve/farmer/bg1.jpg');
  background-size: 100% 100%;
  overflow: hidden;
}
#fmd1 div {
  font-size: .60rem;
  font-weight: normal;
  color: #FFFFFF;
  text-align: center;
  margin-top: 3.78rem;
}
#fmd1 label {
  margin-top: .32rem;
  text-align: center;
  display: block;
  font-size: .20rem;
  font-weight: normal;
  color: #FFFFFF;
  letter-spacing: .2rem;
}

#fmd2 {
  height: 9rem;
  background-image: url('../assets/pic/solve/farmer/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#fmd2 div {
  font-size: .36rem;
  font-weight: bold;
  color: #414141;
  text-align: center;
  margin-top: .71rem;
}

#fmd3 {
  height: 9rem;
  background-image: url('../assets/pic/solve/farmer/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#fmd3 div {
  font-size: .36rem;
  font-weight: bold;
  color: white;
  text-align: center;
  margin-top: .71rem;
}

#fmd4 {
  height: 9.08rem;
  background-image: url('../assets/pic/solve/farmer/bg4.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#fmd4 div {
  font-size: .36rem;
  font-weight: bold;
  color: white;
  text-align: center;
  margin-top: .71rem;
}

#fmd5 {
  height: 9rem;
  background-image: url('../assets/pic/solve/farmer/bg5.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#fmd5 div {
  font-size: .36rem;
  font-weight: bold;
  color: white;
  text-align: center;
  margin-top: .71rem;
}

#fmd6 {
  height: 9rem;
  background-image: url('../assets/pic/solve/farmer/bg6.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#fmd6 div {
  font-size: .36rem;
  font-weight: bold;
  color: #2D2D2D;
  text-align: center;
  margin-top: .71rem;
}

#fmd7 {
  height: 9rem;
  background-image: url('../assets/pic/solve/farmer/bg7.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#fmd7 div {
  font-size: .36rem;
  font-weight: bold;
  color: white;
  text-align: center;
  margin-top: .71rem;
}
</style>
<script>
// @ is an alias to /src
require('@/assets/zt.css')
import mynav1 from '@/components/mynav1'
import myfooter from '@/components/footer'
// import imgct from '@/components/solve/farmer'




export default {
  components: {
    mynav1,myfooter
  },
  data () {
    return {
      ovscroll: false,
      scrdist: 0,
      ftdata: {
        type: 'product',
        lcallback: () => {
          this.init()
        }
      },
      nvdata: {
        sindex: 1,
        type: 'solution',
        lcallback: (stype,sstype) => {
          this.setHead(stype,sstype)
        }
      }
   
    }
  },
  computed: {
  
  },
  methods: {

    onPageScroll (dist) {
      this.ovscroll = dist>93?true:false
      if (dist - this.scrdist > 93) {
        this.scrdist = dist
      } else if (dist < this.scrdist) {
        this.scrdist = dist
      }
      if (dist>0) this.ismenu=false
    },
    setRem() {
        var html = document.querySelector('html');
        var width = html.getBoundingClientRect().width;
        html.style.fontSize = width/20 + 'px'; /// 20
    },
    initWindowEv () {
      /// rem=px/2/14
      window.addEventListener('orientationchange', this.setRem);
      window.addEventListener('resize', this.setRem);
      this.setRem()

      var _this = this
      // var index = 1
      window.onscroll = function (e) {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        _this.onPageScroll(scrollTop)
      }
    },
  
    init () {
      var stype = this.$route.query.stype?this.$route.query.stype:''
      this.setHead(stype)
    }
  },
  mounted () {
    this.initWindowEv()
    this.init()
  }
}
</script>
